import React from 'react';
import PropTypes from 'prop-types';
import css from './SafeDeleteInstancePage.css';

const StatusBox = ({
  children,
  isSuccess = false,
  marginBottom,
  padding,
  large = false,
  className: additionalClassName = '',
  ...props
}) => {
  const baseClass = css.statusBox;
  const statusClass = isSuccess ? css.statusBoxSuccess : css.statusBoxError;
  const sizeClass = large ? css.statusBoxLarge : '';
  const combinedClassName = [
    baseClass,
    statusClass,
    sizeClass,
    additionalClassName,
  ]
    .filter(Boolean)
    .join(' ');

  const customStyles = {};
  if (marginBottom) customStyles.marginBottom = marginBottom;
  if (padding) customStyles.padding = padding;

  return (
    <div className={combinedClassName} style={customStyles} {...props}>
      {children}
    </div>
  );
};

StatusBox.propTypes = {
  children: PropTypes.node.isRequired,
  isSuccess: PropTypes.bool,
  marginBottom: PropTypes.string,
  padding: PropTypes.string,
  large: PropTypes.bool,
};

export default StatusBox;
